/* eslint-disable max-len */
import React, { useEffect, useRef, useState } from 'react';
import MerchantDropdown from '../../../../components/MerchantDropdown';
import DefaultingIcon from '../../../../svgs/DefaultingIcon';
import DueIcon from '../../../../svgs/DueIcon';
import ListIcon from '../../../../svgs/ListIcon';
import LoanCheckIcon from '../../../../svgs/LoanCheckIcon';
import MarkAsPaid from '../../../../svgs/MarkAsPaid';
import NotDueIcon from '../../../../svgs/NotDueIcon';
import { addStyleToEvenElements } from '../../../../utils/helpers';
import { formatCash } from '../../../../utils/tableHelpers';
import MarkAsPaidComp from './MarkAsPaidComp';
import './RepaymentDetailsCard.scss';
import TriggerComp from './TriggerComp';

interface IRepaymentDetailsCard{
  amountDue:any;
  installmentNumber:string;
  loanScheduleId:string;
  status:any;
  dueDate:string;
  refetchLoan?:any;
  index?:number
  firstName?:string;
  id: string;
}
const RepaymentDetailsCard = ({
  amountDue, installmentNumber, loanScheduleId, status, dueDate, refetchLoan, index, firstName, id,
}:IRepaymentDetailsCard) => {
  const [showModal, setShowModal] = useState(false);
  const [markAsPaidModal, setMarkAsPaidModal] = useState(false);
  const [getInstallmentNumber, setGetInstallmentNumber] = useState('');
  const [toggleDropDown, setToggleDropDown] = useState(false);
  const [dropdownOptionState, setDropdownOptionState] = useState({
    checkState: false, title: '',
  });

  const toggleRef = useRef<HTMLDivElement>(null);

  const handleClick = (e) => {
    if (toggleRef?.current?.contains(e.target)) {
      return;
    }
    setToggleDropDown(false);
  };

  useEffect(() => {
    window.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('click', handleClick);
    };
  }, []);
  const validForMarkAsPaid = false;

  const data = [
    {
      title: 'Trigger', disabled: true, icon: <NotDueIcon width="14px" height="14px" colorStyle={dropdownOptionState?.title === 'Trigger' && dropdownOptionState?.checkState ? { fill: '#f6ede6', path: '#FF9300' } : ''} />,
    },
    {
      title: 'Mark as paid',
      disabled: true,
      icon: <MarkAsPaid style={validForMarkAsPaid && dropdownOptionState?.title === 'Mark as paid' && dropdownOptionState?.checkState ? { fill: '#00C48C', path: '#00C48C' } : ''} />,
    },
  ];

  const getStatusDiv = (status, date) => {
    switch (status) {
    case 'Paid':
      return (
        <div className="get-status-cover">
          <div className={status}>
            {date}
          </div>
          <span><LoanCheckIcon /></span>
        </div>
      );
    case 'Not Due':
      return (
        <div className="get-status-cover">
          <div className="not-due">
            {date}
          </div>
          <span><NotDueIcon /></span>
        </div>
      );
    case 'Due':
      return (
        <div className="get-status-cover">
          <div className={status}>
            {date}
          </div>
          <span><DueIcon /></span>
        </div>
      );
    case 'Cancelled':
      return (
        <div className="get-status-cover">
          <div className={status}>
            {date}
          </div>
          <span><NotDueIcon /></span>
        </div>
      );
    default:

      return (
        <div className="get-status-cover">
          <div className={status}>
            {date}
          </div>
          <span><DefaultingIcon /></span>
        </div>
      );
    }
  };

  const handleDropdown = (data) => {
    if (data === 'Trigger') {
      setShowModal(true);
      setToggleDropDown(!toggleDropDown);
    } else if (data === 'Mark as paid') {
      setMarkAsPaidModal(true);
      setToggleDropDown(!toggleDropDown);
    }
  };

  const handleListIcon = (number) => {
    setToggleDropDown(!toggleDropDown);
    setGetInstallmentNumber(number);
  };
  const mouseEnterState = (data) => {
    setDropdownOptionState(data);
  };

  return (
    <div className="col-md-6 col-12 loan-repayment-card-root">
      <div className="loan-repayment-card-cover">
        <div className="repayment-dot" />
        <div className="details-and-button-cover">
          <div className={`row details-and-button-cover-row ${addStyleToEvenElements(index, 'loan-repayment-first-element')}`}>
            <div className="col-sm-4 col-5 details-and-button-cover-col">
              <div className="installment-number">
                {`${installmentNumber} Installment`}
              </div>
              <div className="amount">
                {amountDue ? formatCash(amountDue, '$ ') : '$ 0'}
              </div>
            </div>
            <div className="col-sm-4 col-5 status-and-date-div">
              {
                getStatusDiv(status, dueDate)
              }

              <div className="status-div">
                {status}
              </div>

            </div>
            {loanScheduleId && (
            <div
              className="col-sm-4 col-2 repayment-trigger-div"
              style={{
                marginTop: '2px',
              }}
              ref={toggleRef}
            >

              <ListIcon onClick={() => handleListIcon(installmentNumber)} />

              {
                showModal && <TriggerComp fetchLoan={refetchLoan} loanScheduleId={loanScheduleId} closeModal={() => setShowModal(!showModal)} />
              }
              {
                markAsPaidModal && (
                <MarkAsPaidComp
                  closeModal={() => setMarkAsPaidModal(false)}
                  docName={`${firstName}'s ${installmentNumber} Repayment`}
                  loanScheduleId={id}
                  refetch={refetchLoan}
                />
                )
              }
            </div>
            )}

          </div>

        </div>

      </div>
      {
        toggleDropDown && getInstallmentNumber === installmentNumber && (
          <div className="repayment-option-dropdown">
            <MerchantDropdown data={data} handleDropdown={handleDropdown} hasClassName="special-dropdown-details-list" mouseEnterState={mouseEnterState} checkmouseEvent />
          </div>
        )
      }
    </div>
  );
};
export default RepaymentDetailsCard;
